<div class="removable-chip">
  <span class="removable-chip__text">
    <ng-content></ng-content>
  </span>

  <button class="removable-chip__remove" (click)="onRemoveClick()">
    <i class="removable-chip__icon material-icon material-icon--filled">
      cancel
    </i>
  </button>
</div>
